import { Injectable, Type } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { IEntityDocumentSummary } from '../../message-models/entity-document-summary';
import { DocumentEntityType } from '../../message-models/document-entity-type.enum';
import { switchMap } from 'rxjs/operators';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentUploaderModalComponent } from '../components/document-uploader-modal/document-uploader-modal.component';
import { EcaModalOptions } from '../../shared/models/yesno-modal-options.class';
import { IModalOptions } from '../../common/modals/modal-options.interface';
import { EcaDynamicModalService } from "../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';


@Injectable({
  providedIn: 'root'
})

export class DocumentModalService {

  documentModalRef: IEcaDialogRef;

  constructor(http: HttpClient,
    private ecaDynamicModalService: EcaDynamicModalService,
    private documentTypeService: DocumentTypeService) {
  }

  openDocumentUploaderModal(
    entityDocumentSummary?: IEntityDocumentSummary,
    documentEntityType?: DocumentEntityType,
    headerText?: string,
    options?: IModalOptions): Observable<IEcaDialogRef> {
    return this.documentTypeService.getAllDocumentTypesForEntityType(documentEntityType).pipe(switchMap(documentTypes => {
      if (this.documentModalRef) {
        this.documentModalRef.dynamicDialogRef.close();
      }
      if (options === undefined) {
        options = new EcaModalOptions();
        options.modalClasses += ' modal-eca-success';
      }

      let config = {
        styleClass: 'modal-xl ' + options.modalClasses,
        baseZIndex: 2000,
        showHeader: false,
        header: headerText,
        data: {
          headerText: headerText,
          documentTypes: documentTypes,
          entityDocumentSummary: entityDocumentSummary,
        }
      } as DynamicDialogConfig;

      this.documentModalRef = this.ecaDynamicModalService.openDialog(DocumentUploaderModalComponent, config);
      return of(this.documentModalRef);
    }));
  }
}
